<template>
  <div class="header_box">
    <div class="login_code">
      <span class="welcome">{{ $store.state.welcome }}</span>
      <span class="login_btn" @click="logInHander(1)" v-html="$store.state.logName">登录</span>
      <div class="code">
        <!-- <span
          ><img src="../../assets/images/banner/follow.png" alt=""/>关注我们<img
            class="code_img"
            src="@/assets/images/banner/weChat_code.png"
        /></span> -->
        <span><img src="../../assets/images/banner/download.png" alt="" />手机app下载<img class="code_img" /></span>
        <a href="javascript:void(0)" @click="setHomepage(this)">
          <span><img src="../../assets/images/banner/homepage.png" alt="" />设为首页</span>
        </a>
      </div>
    </div>
    <div class="header">
      <div class="header_img">
        <!-- <img src="../../assets/images/banner/logo.png" /> -->
        <div>
          <span class="zh">广昌抚河源国家湿地公园</span>
          <br />
          <span class="en">Jiangxi Guangchang Fuheyuan National Wetland Pa</span>
        </div>
      </div>
      <div class="header_nav">
        <ul v-html="header"></ul>
      </div>
    </div>
    <el-dialog @keyup.enter.native="logInHander(3)" width="400px" :modal="false" :lock-scroll="false" :title="dialog.title" :visible.sync="dialog.dialogVisible">
      <div v-if="dialog.title === '登录'">
        <el-input placeHolder="请输入账号" v-model="dialog.name" clearable></el-input>
        <el-input placeHolder="请输入密码" v-model="dialog.passWord" show-password clearable></el-input>
      </div>
      <div v-else>是否退出?</div>
      <span slot="footer" class="dialog-footer">
        <button @click="logInHander(3)" class="el-button el-button--primary el-button--small">
          确 定
        </button>
        <button @click="logInHander(2)" class="el-button el-button--danger el-button--small">
          取 消
        </button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import $ from "jquery";
import stepInWetland from "@/components/stepInWetland/stepInWetland";
export default {
  data () {
    return {
      dialog: {
        title: "",
        dialogVisible: false,
        name: "",
        passWord: ""
      },
      header: ""
    };
  },
  components: {
    stepInWetland
  },
  created () {
    window.bannerNavClick = this.bannerNavClick;
    this.header =
      "<li><span onClick=\"bannerNavClick('/')\">首页</span></li>" +
      "<li><span onClick=\"bannerNavClick('/stepInWetland/index/0')\">走进湿地</span></li>" +
      "<li><span onClick=\"bannerNavClick('/wetlandOneMap/index/0')\">湿地管控</span></li>" +
      "<li><span onClick=\"bannerNavClick('/popularScience/index/0')\">科普宣教</span></li>" +
      "<li><span onClick=\"bannerNavClick('/about/about')\">关于我们</span></li>";
  },
  methods: {
    //路由跳转
    bannerNavClick (currentRole, index) {
      this.$router.push(currentRole);
    },
    //设置首页
    setHomepage (obj) {
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage(window.location);
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将 [signed.applets.codebase_principal_support]的值设置为'true',双击即可。"
            );
          }
          var prefs = Components.classes[
            "@mozilla.org/preferences-service;1"
          ].getService(Components.interfaces.nsIPrefBranch);
          prefs.setCharPref("browser.startup.homepage", window.location);
        } else {
          alert(
            "您的浏览器不支持，请按照下面步骤操作：\n1.打开浏览器设置。\n2.点击设置网页。\n3.输入：" +
            window.location +
            "点击确定。"
          );
        }
      }
    },
    // 登录事件
    logInHander (type) {
      if (type === 1) {
        this.dialog.dialogVisible = true;
        if (this.$store.state.logName === "登录") {
          this.dialog.title = "登录";
        } else {
          this.dialog.title = "退出";
        }
      } else if (type === 2) {
        this.dialog.dialogVisible = false;
      } else if (type === 3) {
        if (this.dialog.title === "登录") {
          let uName = this.dialog.name.trim();
          let uPwd = this.dialog.passWord.trim();
          if (uName.length === 0 || uPwd.length === 0) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: "用户名或密码不能为空！",
              type: "warning"
            });
          } else {
            let data = {
              suLoginname: uName,
              suPwd: uPwd,
              soId: this.$store.state.Soid
            };
            this.axios({
              method: "post",
              url: this.$store.state.Url7 + "login",
              data: data,
              headers: {
                "Content-Type": "application/json"
              },
              transformRequest: [
                function () {
                  // 对 data 进行任意转换处理
                  return JSON.stringify(data);
                }
              ]
            })
              .then(res => {
                let data = res.data;
                if (data.success) {
                  this.$message({
                    showClose: true,
                    duration: 1000,
                    message: data.message,
                    type: "success"
                  });
                  sessionStorage.token = data.data.userInfo.token;
                  sessionStorage.uName = data.data.userInfo.realName;
                  this.$store.state.logName =
                    '<i class="el-icon-s-custom" style="font-size:17px; margin-right: 5px;"></i>' +
                    data.data.userInfo.realName;
                  sessionStorage.setItem(
                    "logMessage",
                    JSON.stringify(data.data.userInfo)
                  );
                  sessionStorage.setItem("token", data.data.userInfo.token);
                  this.dialog.dialogVisible = false;
                  this.judgeLog();
                } else {
                  this.$message({
                    showClose: true,
                    duration: 1000,
                    message: data.message,
                    type: "warning"
                  });
                }
              })
              .catch(function (err) {
                console.log(err);
              });
          }
        } else {
          this.$store.state.logName = "登录";
          this.$message({
            showClose: true,
            duration: 1000,
            message: "退出成功",
            type: "success"
          });
          sessionStorage.removeItem("uName");
          sessionStorage.removeItem("logMessage");
          sessionStorage.removeItem("token");
          this.dialog.dialogVisible = false;
          this.judgeLog();
          this.$router.push({
            path: "/"
          });
        }
      }
    }
  },
  mounted () {
    if (sessionStorage.uName) {
      this.$store.state.logName =
        '<i class="el-icon-s-custom" style="font-size:17px; margin-right: 5px;"></i>' +
        sessionStorage.uName;
    }
  }
};
</script>

<style lang="scss">
// .log_message {
//   position: absolute;
//   right: 15px;
//   top: 33px;
//   z-index: 233;
//   font-size: 18px;
//   cursor: pointer;
//   transition: 0.2s linear;
//   padding: 5px;
//   border: 1px solid;
//   border-radius: 5px;
// }
// .log_message:hover {
//   color: #08961f;
// }
// .login_code {
//   z-index: 112;
//   height: 36px;
//   padding: 0 20%;
//   background: #f3f7f5;

//   span {
//     color: #999999;
//     line-height: 36px;
//   }

//   .login_btn {
//     margin-left: 50px;
//     &:hover {
//       text-decoration: underline;
//       color: #08961e;
//       cursor: pointer;
//     }
//   }

//   .code {
//     float: right;
//     position: relative;
//     cursor: pointer;

//     span {
//       padding: 0 10px;
//       position: relative;

//       img {
//         width: 20px;
//         top: 4px;
//         right: 3px;
//         position: relative;
//       }

//       .code_img {
//         width: 120px;
//         position: absolute;
//         top: 28px;
//         transform: translateY(20px);
//         visibility: hidden;
//         transition: 0.2s linear;
//         z-index: 999999;
//         opacity: 0;
//       }
//       &:hover .code_img {
//         visibility: visible;
//         transform: translateY(0);
//         opacity: 1;
//       }
//     }
//   }
// }
// .header {
//   z-index: 111;
//   background: #ffffff;
//   height: 100px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
// }
// .header_img {
//   float: left;
//   height: 100%;

//   img {
//     height: calc(100% - 40px);
//     margin: 20px 0;
//     float: left;
//   }

//   div {
//     width: 350px;
//     margin: 22px 0 22px 75px;
//     color: #08961e;

//     .zh {
//       font-size: 27px;
//     }
//     .en {
//       font-size: 12px;
//     }
//   }
// }
// .header_nav {
//   line-height: 100px;
//   float: left;
// }
// .header_nav li {
//   text-align: center;
//   width: 100px;
//   box-sizing: border-box;
//   float: left;
//   transition: all 0.2s;
//   position: relative;
// }
// .header_nav li .header_native,
// .select_hide .header_native {
//   color: #08961f;
// }
// .header_nav li span {
//   transition: all 0.2s;
//   padding-bottom: 5px;
//   cursor: pointer;
//   color: black;
//   font-size: 20px;
//   font-weight: bold;
// }
// .header_nav li:after,
// .header_nav li:before {
//   content: "";
//   position: absolute;
//   top: 43%;
//   right: 0;
//   height: 15px;
//   width: 0px;
//   background-color: black;
// }
// .header_nav > ul > li:last-child:after,
// .header_nav > ul > li:last-child:before {
//   height: 0;
// }
// .header_nav > ul > li > span:hover,
// .header_nav > ul > li:hover > span {
//   color: #08961f;
// }
// .hide {
//   position: absolute;
//   z-index: 2333;
//   height: 0;
//   left: 0;
//   top: 70px;
//   background-color: #17a900;
//   width: 100%;
//   overflow: hidden;
// }
// .hide,
// .hide > div {
//   transition: all 0.3s ease-out 0s;
// }
// .hide > div {
//   position: absolute;
//   display: block;
//   width: 100%;
// }

// @media only screen and (max-width: 1500px) {
//   .header_nav li span {
//     font-size: 16px;
//   }
//   .header_img {
//     div {
//       display: none;
//     }
//   }
// }
</style>
<style>
/* // .el-dialog__header {
//   background: #f8f8f8;
//   border-bottom: 1px solid #eee;
// }
// .el-input {
//   margin-bottom: 22px;
// }
// .el-dialog {
//   display: flex;
//   flex-direction: column;
//   margin: 0 !important;
//   position: absolute;
//   z-index: 2333;
//   top: 50%;
//   left: 50%;
//   transform: translate(-50%, -50%);
//   max-height: calc(100% - 30px);
//   max-width: calc(100% - 30px);
// }
// .el-dialog__body {
//   padding: 30px 20px 0 20px !important;
//   height: 154px;
//   flex: 1;
//   overflow: auto;
//   padding-bottom: 0;
//   background: white;
// }
// .el-dialog__footer {
//   text-align: center;
//   background: white;
//   position: relative;
//   top: -1px;
// } */
</style>


// WEBPACK FOOTER //
// src/components/public/headerB.vue